import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken, getToken, apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = user
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(false);
      setReady(true);
      return null;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setReady(true);
      return data.user;
    } catch (e) {
      setToken(null);
      setUser(false);
      setReady(true);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name, ref = "") => {
    const { data } = await api.post("/auth/register", { email, password, name, ref });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, setUser, refresh, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
